<template>
    <Icon
        :name="name"
        :width="width"
        :height="height"
        :color="color"
        @click="$emit('click')"
    >
        <rect
            class="a"
            x="0.75"
            y="0.747"
            width="22.5"
            height="22.5"
            rx="1.5"
            ry="1.5"
        />

        <circle class="a" cx="7.5" cy="16.497" r="2.25" />

        <path class="a" d="M5.205,10.126a6.807,6.807,0,0,1,8.4,9.36" />

        <path class="a" d="M5.359,5.445a11.279,11.279,0,0,1,13,14.08" />
    </Icon>
</template>

<script>
import Icon from '@/components/icons/Icon'

export default {
    name: 'RfidIcon',
    components: {
        Icon,
    },
    props: {
        name: {
            type: String,
            default: '',
        },
        width: {
            type: [Number, String],
            default: 18,
        },
        height: {
            type: [Number, String],
            default: 18,
        },
        color: {
            type: String,
            default: '#000',
        },
    },
}
</script>

<style lang="scss" scoped>
.a {
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.5px;
}
</style>
